export default function getBrowserSystemInfo(globalObject: any, mach: any): Record<string, any> {
  const navigatorInfo = globalObject.navigator || {};
  const screenInfo = globalObject.screen || {};
  const env = mach?.env || {};
  let localeInfo: Record<string, any> = {};
  try {
    localeInfo = mach?.requireModule?.('Intl')?.getCurrentLocaleInfo?.() || {};
  } catch (error) {
    localeInfo = {};
  }
  let resolvedLocale = '';
  try {
    resolvedLocale = globalObject.Intl?.DateTimeFormat?.().resolvedOptions?.().locale || '';
  } catch (error) {
    resolvedLocale = '';
  }
  const systemLanguage = navigatorInfo.language || resolvedLocale || '';
  const appLanguage = localeInfo.locale || resolvedLocale || systemLanguage;
  const windowWidth = globalObject.innerWidth || 0;
  const windowHeight = globalObject.innerHeight || 0;
  return {
    platform: 'web',
    osName: navigatorInfo.platform || 'web',
    system: navigatorInfo.userAgent || '',
    brand: 'web',
    model: navigatorInfo.userAgent || 'browser',
    version: env.version || '',
    appVersion: env.version || '',
    language: appLanguage,
    locale: appLanguage,
    region: localeInfo.region || '',
    screenWidth: screenInfo.width || windowWidth,
    screenHeight: screenInfo.height || windowHeight,
    windowWidth,
    windowHeight,
    pixelRatio: globalObject.devicePixelRatio || 1,
    safeArea: {
      left: 0,
      top: 0,
      right: windowWidth,
      bottom: windowHeight,
      width: windowWidth,
      height: windowHeight,
    },
    _mt: {
      systemLanguage,
      env: 'web',
    },
  };
}
